import { getPendingSummary } from "src/api/approveAllowanceQueue";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { defaultListParams } from "src/features/common/constants/defaultListParams";

const ApproveAllowanceQueue = () => {
  return (
    <PageConfigProvider
      translatePrefix="approveAllowanceQueue"
      initFields={{}}
      getListParams={() => ({
        ...defaultListParams,
        showAllSmartAccountType: true,
      })}
      getTableDataApiFunc={getPendingSummary}>
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default ApproveAllowanceQueue;
